import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ContentAccess = styled.div`
  padding: 0px 10px;
  overflow: auto;
  height: 100%;
  .title-access {
    font-family: Nunito Sans Bold;
    font-size: 17px;
    color: #3E3E5B;
    margin-top: 10px;
  }
  .separator {
    width: 100%;
    margin: 10px 0;
    border-bottom: 1px solid #EFEFF9;
  }
  .programs-access {
    margin-bottom: 10px;
    color: #1F1F52;
    font-family: Nunito Sans;
    font-size: 17px;
  }
  .programs-list {
    .program-item {
      margin-bottom: 20px;
      .program-name {
        font-family: Nunito Sans;
        font-size: 17px;
        color: #3E3E5B;
      }
      .program-patients {
        font-family: Nunito Sans;
        font-size: 12px;
        color: #707582;
      }
    }
  }
`;